export default __webpack_public_path__ + "static/media/fieldComparisonImage.b45e6f73.png";